import PaymentPlanError from './PaymentPlanError';
class PaymentPlansInvalidQueryParam extends PaymentPlanError {
    constructor(queryParam, value, options) {
        super(`Query param ${queryParam} with the value ${value} is invalid`, options);
    }
}
export default PaymentPlansInvalidQueryParam;
